






import { defineComponent } from '@nuxtjs/composition-api'
import { ImageEnhancementConfigInterface } from '~/types/image-enhancement/imageEnhancementTypes'
import { PLACEHOLDER_IMAGE_FILENAME } from '@/common/utils/product/constants'

export default defineComponent({
  name: 'ImageEnhancementError',
  props: {
    config: {
      type: Object as () => ImageEnhancementConfigInterface,
      required: true,
    },
  },
  setup() {
    return {
      PLACEHOLDER_IMAGE_FILENAME,
    }
  },
})
